/**
 * Decode the payload of a JWT without verifying its signature.
 *
 * @param token - JWT string in the format header.payload.signature
 * @returns The decoded payload object in format { exp: number, iat: number, ... }
 */
export function decodeJWT(token: string) {
  const parts = token.split('.');
  const payload = parts[1];

  if (!payload) {
    return undefined;
  }

  const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
      .join('')
  );

  return JSON.parse(jsonPayload) as {
    exp: number;
    iat: number;
    given_name: string;
    family_name: string;
  };
}
